import { createContext } from 'react';

export const AlertMessageContext = createContext({
    successMessage: '',
    errorMessage: '',
    setSuccessMessage: () => {},
    setErrorMessage: () => {},
});
